import { useEffect } from "react";
import type { RootState } from "@/store/store";
import { REDIRECT_URL } from "@/constant/constantsThrougoutProject";
import { getFeatureRedirect } from "@/utils/featureStatus";
import { dequal } from "dequal";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const Home: React.FC<{}> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const featureStatus = useSelector(
    (state: RootState) => state.featureStatus,
    (prev, next) => dequal(prev, next),
  );

  useEffect(() => {
    if (location.pathname !== "/") return;

    const redirectUrl = getFeatureRedirect(featureStatus as any);
    if (!redirectUrl) {
      // featureStatus not yet populated (all flags still false) — wait for next update
      return;
    }

    const redirectUrlFromSession = sessionStorage.getItem(REDIRECT_URL);
    const redirectionUrl = redirectUrlFromSession
      ? new URL(redirectUrlFromSession || "")
      : undefined;
    if (
      redirectUrlFromSession &&
      redirectionUrl &&
      redirectionUrl?.pathname !== "/"
    ) {
      sessionStorage.removeItem(REDIRECT_URL);
      window.location.href = redirectUrlFromSession;
    } else {
      navigate(
        { pathname: redirectUrl as string, search: location.search },
        { replace: true },
      );
    }
  }, [featureStatus]);

  return null;
};

export default Home;
